import { Partner, partners } from 'noddi-types';
import { useCurrentTheme, useSetTheme } from '../stores/themeStore';

const themes = Object.entries(partners).map(([key, value]) => ({
  id: key,
  name: value
}));

export const ThemeSelector = () => {
  const currentTheme = useCurrentTheme();
  const setTheme = useSetTheme();

  return (
    <div className='fixed right-20 top-4 z-50 hidden rounded-lg bg-white p-1 shadow-lg md:block'>
      <label htmlFor='theme-select' className='mb-2 block text-sm font-medium'>
        Select Theme
      </label>
      <select
        id='theme-select'
        value={currentTheme}
        onChange={(e) => setTheme(e.target.value as Partner)}
        className='block w-full rounded-md shadow-sm focus:border-primary focus:ring-primary sm:text-sm'
      >
        {themes.map((theme) => (
          <option key={theme.id} value={theme.id}>
            {theme.name}
          </option>
        ))}
      </select>
    </div>
  );
};
